import { render } from "./MemberBalancePointsReport.vue?vue&type=template&id=19a649f8&scoped=true"
import script from "./MemberBalancePointsReport.vue?vue&type=script&lang=js"
export * from "./MemberBalancePointsReport.vue?vue&type=script&lang=js"

import "./MemberBalancePointsReport.vue?vue&type=style&index=0&id=19a649f8&scoped=true&lang=css"

import exportComponent from "/var/www/html/minty.crm.frontend.merchant/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19a649f8"]])

export default __exports__